module.exports = __webpack_public_path__ + "static/media/user_d_fav_1.11e441d4.png";